import React, { Fragment, useState, useContext } from 'react'
import { ReactComponent as FilterIco } from '../media/ColumnFilter.svg'
import { Modal } from 'components/Modal'
import { useTranslation } from 'react-i18next'
import { Checkbox } from 'components/forms'
import { DataTableContext } from './DataTable'
import styled from 'styled-components'

const CheckboxList = styled.div`
	display: flex;
	flex-direction: column;
	height: 400px;
	flex-wrap: wrap;
`

const ColumnFilter = () => {
	const [showModal, setShowModal] = useState(false)
	const [t] = useTranslation()
	const { columns } = useContext(DataTableContext)

	const columnsList = columns.map(({ id, Header, getToggleHiddenProps }) => {
		return <Checkbox noForm key={id} field={id} label={Header} {...getToggleHiddenProps()}/>
	})

	return(
		<Fragment>
			<FilterIco onClick={() => setShowModal(true)}/>
			{showModal &&
				<Modal width={910} label={t('common.strings.table_column_filter')} unmount={() => setShowModal(false)}>
					<CheckboxList>
						{columnsList}
					</CheckboxList>
				</Modal>
			}
		</Fragment>
	)
}

export default ColumnFilter
